export default "__VITE_ASSET__Daety6U8__"